+function ($) {

	"use strict";

	$(document)
		.on('ready', function () {
			$('#pricing-table-regions').find('.pricing-table__region').hide();
		})
		.on('change.region', '#region-selector', function (event) {
			var selectedRegion = false;

			for (var i = 0; i < event.target.options.length; i++) {
				if (event.target.options[i].selected) {
					selectedRegion = event.target.options[i].value;
				}
			}

			if (selectedRegion) {
				$(this).closest('.pricing-table__location-type').find('.pricing-table__region').hide();
				$('#pricing-table-region-' + selectedRegion).show();
			}
		});

}(jQuery);
